import request from "../request";
import Url from "../url/knowledge";

const getKnowledgesDataByType = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getKnowledgesDataByType + path, data, options);
};
const getKnowledgesDetails = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getKnowledgesDetails + path, data, options);
};
const setKnowledgesData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setKnowledgesData + path, data, options);
};
const updateKnowledgesData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateKnowledgesData + path, data, options);
};
const deleteKnowledgesData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.deleteKnowledgesData + path, data, options);
};
const updateKnowledgesOrders = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateKnowledgesOrders + path, data, options);
};
const getKnowledgesCountsRecordMemberCountsByKid = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getKnowledgesCountsRecordMemberCountsByKid + path,
    data,
    options
  );
};
const setKnowledgesLikes = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setKnowledgesLikes + path, data, options);
};
const deleteKnowledgesLikes = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.deleteKnowledgesLikes + path, data, options);
};

export default {
  getKnowledgesDataByType,
  getKnowledgesDetails,
  setKnowledgesData,
  updateKnowledgesData,
  deleteKnowledgesData,
  updateKnowledgesOrders,
  getKnowledgesCountsRecordMemberCountsByKid,
  setKnowledgesLikes,
  deleteKnowledgesLikes,
};
